import { getTxtIdMapperPath } from "../../router/txtIdMapper";
import { apiS } from "./api-base";
import { getESGReqHeader } from "./tool-service";

export const getPersonalInfo = async () => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1020101'),
        ReqBody: {}
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1020101")}`, method: 'post', data: ReqBody })
}

export const updatePersonalInfo = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1020102'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1020102")}`, method: 'post', data: ReqBody })
}

//個人資料更新 統一檢核
export const F1020102Before = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1020102'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1020102", true)}`, method: 'post', data: ReqBody })
}

//取得登入者的功能清單和個人資訊
export const getfuncListAndLoginInfo = async () => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F0020102'),
        ReqBody: {}
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F0020102")}`, method: 'post', data: ReqBody })
}

//角色清單查詢
export const getRoleList = async (reqBody = {}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F2020101'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F2020101")}`, method: 'post', data: ReqBody })
}

//角色新增 統一檢核
export const F2020102Before = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F2020102'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F2020102", true)}`, method: 'post', data: ReqBody })
}

//角色新增
export const createNewRole = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F2020102'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F2020102")}`, method: 'post', data: ReqBody })
}

//角色更新 統一檢核
export const F2020109Before = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F2020109'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F2020109", true)}`, method: 'post', data: ReqBody })
}

//角色更新
export const updateRole = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F2020109'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F2020109")}`, method: 'post', data: ReqBody })
}

//查詢子帳戶清單
export const querySubAccData = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F2010201'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F2010201")}`, method: 'post', data: ReqBody })
}


//密碼變更
export const updateNewPcode = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1020201'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1020201")}`, method: 'post', data: ReqBody })
}

//密碼變更 統一檢核
export const F1020201Before = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1020201'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1020201", true)}`, method: 'post', data: ReqBody })
}

//更新/刪除子帳戶清單
export const updateSubAccData = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F2010202'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F2010202")}`, method: 'post', data: ReqBody })
}

//更新子帳戶清單 統一檢核
export const F2010202Before = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F2010202'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F2010202", true)}`, method: 'post', data: ReqBody })
}

//畫面初始
export const initSubAccData = async () => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F2010204'),
        ReqBody: {}
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F2010204")}`, method: 'post', data: ReqBody })
}

// 新增管理者子帳戶
export const createManagerAcct = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F2010205'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F2010205")}`, method: 'post', data: ReqBody })
}

// 新增邀請子帳戶前檢核
export const F2010206Before = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F2010206'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F2010206", true)}`, method: 'post', data: ReqBody })
}

// 新增邀請子帳戶
export const CreateInviteSubAcct = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F2010206'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F2010206")}`, method: 'post', data: ReqBody })
}

//角色權限設定查詢
export const queryRoleFunctionByRoleSeq = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F2020103'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F2020103")}`, method: 'post', data: ReqBody })
}

//角色權限設定編輯
export const updateRoleFunctionIdList = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F2020104'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F2020104")}`, method: 'post', data: ReqBody })
}

//角色場所設定查詢
export const queryRolePlaceByRoleSeq = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F2020105'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F2020105")}`, method: 'post', data: ReqBody })
}

//角色場所設定編輯
export const updateRolePlaceList = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F2020106'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F2020106")}`, method: 'post', data: ReqBody })
}

//角色產品設定查詢
export const queryRoleProductByRoleSeq = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F2020107'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F2020107")}`, method: 'post', data: ReqBody })
}

//角色產品設定編輯
export const updateRoleProductList = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F2020108'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F2020108")}`, method: 'post', data: ReqBody })
}

//使用者角色設定查詢
export const queryRoleUserGroupList = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F2020201'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F2020201")}`, method: 'post', data: ReqBody })
}

//使用者角色設定編輯
export const updateRoleUserGroupList = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F2020202'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F2020202")}`, method: 'post', data: ReqBody })
}

//審核子帳戶(通過/退回)
export const reviewSubAccount = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F2010203'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F2010203")}`, method: 'post', data: ReqBody })
}